module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_7_1.5f947618.jpeg";